/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Modal,
  Tabs,
  Descriptions,
  Avatar,
  Badge,
  Typography,
  Tag,
  Card,
  Space,
  Upload,
  message,
  Button,
  Input,
  Form,
  DatePicker,
  Radio,
  Checkbox,
  Row,
  Col,
  Divider,
  notification,
} from 'antd';
import { checkToken } from 'api/utils';
import {
  UploadOutlined,
  UserOutlined,
  SaveOutlined,
  CheckOutlined,
  PlusOutlined,
  DeleteOutlined,
  EditOutlined,
} from '@ant-design/icons';
import Table from 'components/Table';
import currencyFormatter from 'utils/currencyFormatter';
import { getEstadosGlobales } from 'api/catalogos';
import { getCandidato, getCandidatovistaOptimized } from 'api/catalogos/Candidatos';
import moment from 'moment';
import { patchEntrevista } from 'api/Entrevistas';
import {
  deleteEntrevistaFamiliar, getEntrevistasFamiliar, getEntrevistasFamiliarParentesco, patchEntrevistaFamiliar, postEntrevistaFamiliar,
} from 'api/EntrevistasFamiliar';
import Select from 'components/Select';
import { getEntrevistasSalud, patchEntrevistaSalud, postEntrevistaSalud } from 'api/EntrevistasSalud';
import {
  deleteEntrevistaTrayectoria, getEntrevistasTrayectoria, patchEntrevistaTrayectoria, postEntrevistaTrayectoria,
} from 'api/EntrevistasTrayectoria';
import { getEntrevistaCompetencias, getEntrevistasCompetencias, patchEntrevistaCompetencias } from 'api/EntrevistasCompetencias';
import {
  getEntrevistasTrayectoriaPreguntas, getEntrevistaTrayectoriaPreguntas, patchEntrevistaTrayectoriaPreguntas, postEntrevistaTrayectoriaPreguntas,
} from 'api/EntrevistasTrayectoriaPreguntas';
import {
  getEntrevistaNotas, getEntrevistasNotas, patchEntrevistaNotas, postEntrevistaNotas,
} from 'api/EntrevistasNotas';
import {
  getEntrevistasCaracteristicas, getEntrevistasCaracteristicasCaracteristicas, patchEntrevistaCaracteristicas, postEntrevistaCaracteristicas,
} from 'api/EntrevistasCaracteristicasObservables';
import { set } from 'lodash';
import CustomSearch from 'components/customSearch';
import { getEmpleado, getEmpleadosConDatosOpFilteredPaginated } from 'api/estructuraOrganizacional/empleados';
import { getPlaza } from 'api/catalogos/plazas';
import { getDatoOperacionalesDeEmpleados } from 'api/estructuraOrganizacional/datosOperacionalesDeEmpleados';
import { getEstadosCiviles, getGeneros } from 'api/usuarios';
import FormSubmitControls from 'components/FormSubmitControls';
import EditableTable from 'components/EditableTable';
import CurrencyInput from 'components/CurrencyInput';

const { TabPane } = Tabs;
const { Title, Text } = Typography;
const { TextArea } = Input;

export default function EntrevistaNoModal({
  entrevista, onClose, permission,
}) {
  const [resumen, setResumen] = useState('');
  const [archivo, setArchivo] = useState(null);
  const [activeTab, setActiveTab] = useState('evaluacion');
  const [form] = Form.useForm();
  const [saludForm] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const [candidatoDetalle, setCandidatoDetalle] = useState(null);
  const [entrevistasFamiliar, setEntrevistasFamiliar] = useState([]);
  const [entrevistasFamiliarParentesco, setEntrevistasFamiliarParentesco] = useState([]);
  const [entrevistasSalud, setEntrevistasSalud] = useState([]);
  const [entrevistasTrayectoria, setEntrevistasTrayectoria] = useState([]);
  const [entrevistaCompetencias, setEntrevistaCompetencias] = useState(null);
  const [entrevistatrasectoriaPreguntas, setEntrevistaTrayectoriaPreguntas] = useState(null);
  const [estados, setEstados] = useState([]);
  const [preguntasForm] = Form.useForm();
  const [entrevistaPreguntas, setEntrevistaPreguntas] = useState(null);
  const [entrevistasNotas, setEntrevistasNotas] = useState([]);
  const [entrevistasCaracteristicas, setEntrevistasCaracteristicas] = useState([]);
  const [entrevistasCaracteristicasCaracteristicas, setEntrevistasCaracteristicasCaracteristicas] = useState([]);
  const [notasForm] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedData, setSelectedData] = useState(null);

  const [openSearchEntrevistador, setOpenSearchEntrevistador] = useState(false);
  const [dataSearchEntrevistador, setDataSearchEntrevistador] = useState([]);
  const [baseURIPaginationEntrevistador, setBaseURIPaginationEntrevistador] = useState('catalogos/dato-operacional-del-empleado-paginado/?empleados_filter=');
  const [selectedEntrevistador, setSelectedEntrevistador] = useState(null);

  // Estados para modales de agregar datos
  const [showTrayectoriaModal, setShowTrayectoriaModal] = useState(false);
  const [showFamiliarModal, setShowFamiliarModal] = useState(false);
  const [trayectoriaData, setTrayectoriaData] = useState([]);
  const [familiarData, setFamiliarData] = useState([]);
  const [competenciasData] = useState([]);
  const [showCompetenciaModal, setShowCompetenciaModal] = useState(false);
  const [competenciaForm] = Form.useForm();
  const [selectedCompetencia, setSelectedCompetencia] = useState(null);
  const [puesto, setPuesto] = useState();
  const [adminPlazas, setAdminPlazas] = useState([]);
  const [plaza, setPlaza] = useState();
  const [area, setArea] = useState();
  const [puestos, setPuestos] = useState();
  const [plazas, setPlazas] = useState();
  const [generos, setGeneros] = useState([]);
  const [estadoCivil, setEstadoCivil] = useState([]);

  // Formularios para modales
  const [trayectoriaForm] = Form.useForm();
  const [familiarForm] = Form.useForm();
  const [selectedTrayectoria, setSelectedTrayectoria] = useState(null);

  const columnsCaracteristicasObservables = [
    {
      titleText: 'Característica Observables',
      dataIndex: 'caracteristicaNombre',
      key: 'caracteristicaNombre',
    },
    {
      titleText: 'Presente',
      dataIndex: 'valor',
      key: 'valor',
      render: (_, record) => (
        <Radio
          checked={record.valor === true}
          onChange={() => {
            setEntrevistasCaracteristicas((prev) => prev.map((item) => (item.id === record.id
              ? { ...item, valor: true }
              : item)));
          }}
        />
      ),
    },
    {
      titleText: 'No Presente',
      dataIndex: 'valor',
      key: 'valor',

      render: (_, record) => (
        <Radio
          checked={record.valor === false}
          onChange={() => {
            setEntrevistasCaracteristicas((prev) => prev.map((item) => (item.id === record.id
              ? { ...item, valor: false }
              : item)));
          }}
        />
      ),
    },
  ];

  useEffect(() => {
    if (/* !isOpen  || */ !entrevista?.id || !entrevista?.candidato) {
      return () => { }; //  función vacía en lugar de "return;"
    }

    let mounted = true;

    const getValor = (c) => {
      if (c.presente === true) return true;
      if (c.no_presente === true) return false;
      return null;
    };

    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      try {
        const [
          _estados,
          _candidatoDetalle,
          _entrevistasFamiliar,
          _entrevistasFamiliarParentesco,
          _entrevistasSalud,
          _entrevistasTrayectoria,
          _entrevistaCompetencias,
          _entrevistasTrayectoriaPreguntas,
          _entrevistasNotas,
          _entrevistasCaracteristicas,
          _entrevistasCaracteristicasCaracteristicas,
          _generos,
          _estadosCivil,
        ] = await Promise.all([

          getEstadosGlobales(),
          getCandidato(entrevista.candidato),
          getEntrevistasFamiliar({ entrevista: entrevista.id }),
          getEntrevistasFamiliarParentesco({ entrevista: entrevista.id }),
          getEntrevistasSalud({ entrevista: entrevista.id }),
          getEntrevistasTrayectoria({ entrevista: entrevista.id }),
          getEntrevistasCompetencias({ entrevista: entrevista.id }),
          getEntrevistasTrayectoriaPreguntas({ entrevista: entrevista.id }),
          getEntrevistasNotas({ entrevista: entrevista.id }),
          getEntrevistasCaracteristicas({ entrevista: entrevista.id }),
          getEntrevistasCaracteristicasCaracteristicas(),
          getGeneros(),
          getEstadosCiviles(),
        ]);

        if (mounted) {
          setEstadoCivil(_estadosCivil);
          setGeneros(_generos);
          setEstados(_estados);
          setCandidatoDetalle(_candidatoDetalle);
          setEntrevistasCaracteristicasCaracteristicas(_entrevistasCaracteristicasCaracteristicas);

          // Tablas
          setEntrevistasFamiliar(_entrevistasFamiliar.results || []);
          setEntrevistasFamiliarParentesco(_entrevistasFamiliarParentesco || []);
          setEntrevistasSalud(_entrevistasSalud.results || []);
          setEntrevistasTrayectoria(_entrevistasTrayectoria.results || []);
          setEntrevistaCompetencias(_entrevistaCompetencias.results || []);
          setEntrevistasNotas(_entrevistasNotas.results || []);
          setEntrevistasCaracteristicas(
            (_entrevistasCaracteristicas.results || []).map((c) => {
              const catalogo = _entrevistasCaracteristicasCaracteristicas.find(
                (cat) => cat.id === c.caracteristica_observable,
              );
              return {
                ...c,
                key: c.id,
                valor: getValor(c),
                caracteristicaNombre: catalogo ? catalogo.nombre : `#${c.caracteristica_observable}`,
              };
            }),
          );

          // Preload forms
          if (_entrevistasNotas.results?.[0]) {
            const nota = _entrevistasNotas.results[0];
            notasForm.setFieldsValue(nota);

            //  cargar entrevistador si ya está guardado
            if (nota.empleado) {
              const empleadoId = nota.empleado;

              const _empleado = await getEmpleado(empleadoId);
              const [datoOperacional] = await getDatoOperacionalesDeEmpleados({ empleado: empleadoId });

              let plazaDetalle = null;
              if (datoOperacional?.plaza) {
                plazaDetalle = await getPlaza(datoOperacional.plaza);
              }

              const nombreCompleto = `${_empleado.numero_de_empleado} - ${_empleado.nombre} ${_empleado.apellido_paterno} ${_empleado.apellido_materno || ''}`;

              const valoresForm = {
                entrevistador: nombreCompleto,
                area_entrevistador: plazaDetalle?.directorio_de_area_nombre || '',
                puesto_entrevistador: plazaDetalle?.puesto_descripcion || '',
              };

              setSelectedEntrevistador({
                ..._empleado,
                area: valoresForm.area_entrevistador,
                puesto: valoresForm.puesto_entrevistador,
              });

              notasForm.setFieldsValue({
                ...nota, // mantiene observaciones
                ...valoresForm, // añade entrevistador, área y puesto
              });
            }
          }

          if (_entrevistasTrayectoriaPreguntas.results?.[0]) {
            preguntasForm.setFieldsValue(_entrevistasTrayectoriaPreguntas.results[0]);
          }
          if (_entrevistasSalud.results?.[0]) {
            saludForm.setFieldsValue(_entrevistasSalud.results[0]);
          }

          form.setFieldsValue({
            sueldo_solicitado: entrevista.sueldo_solicitado,
            disponibilidad_laboral: entrevista.disponibilidad_laboral,
          });

          // Tablas familiares y trayectorias
          setFamiliarData((_entrevistasFamiliar.results || []).map((f) => ({ key: f.id, ...f })));
          setTrayectoriaData(_entrevistasTrayectoria.results || []);

          setEntrevistaTrayectoriaPreguntas(_entrevistasTrayectoriaPreguntas.results || []);
          setEntrevistaPreguntas(_entrevistasTrayectoriaPreguntas.results?.[0] || null);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchAll();

    return () => {
      mounted = false;
    };
    // eslint-disable-next-line
  }, [/* isOpen, */ entrevista]);

  const onEditTrayectoria = (record) => {
    setSelectedTrayectoria(record);
    trayectoriaForm.setFieldsValue({
      periodoInicial: moment(`${record.periodo_inicial}-${record.periodo_inicial_mes}`, 'YYYY-MM'),
      periodoFinal: moment(`${record.periodo_final}-${record.periodo_final_mes}`, 'YYYY-MM'),
      puesto: record.puesto,
      sueldo: record.sueldo,
      personal: record.personal_a_cargo,
      responsabilidades: record.responsabilidades,
      motivo: record.motivo_de_baja,
    });
    setShowTrayectoriaModal(true);
  };

  const onChangeEntrevistador = async (row) => {
    if (!row) {
      setSelectedEntrevistador(null);
      form.resetFields(['entrevistador', 'area_entrevistador', 'puesto_entrevistador']);

      return;
    }

    try {
      //  Si row es un número (id de empleado), usamos directamente ese id
      const empleadoId = typeof row === 'number' ? row : row.id || row.empleado;

      //  Obtener datos del empleado
      const _empleado = await getEmpleado(empleadoId);

      //  Obtener datos operacionales (plaza incluida)
      const [datoOperacional] = await getDatoOperacionalesDeEmpleados({ empleado: empleadoId });

      //  Obtener detalle de plaza (si existe)
      let plazaDetalle = null;
      if (datoOperacional?.plaza) {
        plazaDetalle = await getPlaza(datoOperacional.plaza);
      }

      //  Construir nombre completo
      const nombreCompleto = `${_empleado.numero_de_empleado} - ${_empleado.nombre} ${_empleado.apellido_paterno} ${_empleado.apellido_materno || ''}`;

      //  Valores que van al form
      const valoresForm = {
        entrevistador: nombreCompleto,
        area_entrevistador: plazaDetalle?.directorio_de_area_clave_y_nombre || '',
        puesto_entrevistador: plazaDetalle?.puesto_clave_y_descripcion || '',
        plaza_entrevistador: plazaDetalle?.clave_y_descripcion || '',
      };

      //  Guardamos empleado enriquecido en el estado
      setSelectedEntrevistador({
        ..._empleado,
        area: valoresForm.area_entrevistador,
        puesto: valoresForm.puesto_entrevistador,
      });

      //  Esto llena los inputs de antd
      notasForm.setFieldsValue(valoresForm);
    } catch (err) {
      message.error('No se pudo cargar la información del entrevistador');
    }
  };

  const searchDataEntrevistador = async (empId, nombreEmp, apPatEmp, apMatEmp) => {
    let baseURI = 'catalogos/dato-operacional-del-empleado-paginado/?empleados_filter=';

    if (empId) baseURI += `numero_de_empleado=${empId};`;
    if (nombreEmp) baseURI += `nombre=${nombreEmp};`;
    if (apPatEmp) baseURI += `apellido_paterno=${apPatEmp};`;
    if (apMatEmp) baseURI += `apellido_materno=${apMatEmp};`;

    setBaseURIPaginationEntrevistador(baseURI);
    const _empleados = await getEmpleadosConDatosOpFilteredPaginated(baseURI);
    setDataSearchEntrevistador(_empleados);
  };

  const columnsEmpleado = [
    {
      titleText: 'No. de Empleado',
      dataIndex: 'empleado',
      key: 'numero_de_empleado',
      width: 200,
      render: (empObject) => empObject?.numero_de_empleado || '',
    },
    {
      titleText: 'Nombre',
      dataIndex: 'empleado',
      key: 'nombre',
      width: 250,
      render: (empObject) => empObject?.nombre || '',
    },
    {
      titleText: 'Apellido Paterno',
      dataIndex: 'empleado',
      key: 'apellido_paterno',
      width: 250,
      render: (empObject) => empObject?.apellido_paterno || '',
    },
    {
      titleText: 'Apellido Materno',
      dataIndex: 'empleado',
      key: 'apellido_materno',
      width: 250,
      render: (empObject) => empObject?.apellido_materno || '',
    },

    // {
    //   titleText: 'Puesto',
    //   dataIndex: 'empleado',
    //   key: 'puesto',
    //   width: 300,
    //   render: (empObject) => {
    //     const adminPlazaEmp = adminPlazas?.find((admP) => admP?.empleado === empObject?.id);
    //     const plazaEmp = plazas?.find((pl) => pl?.id === adminPlazaEmp?.plaza);
    //     const puestoEmp = puestos?.find((p) => p?.id === plazaEmp?.puesto);
    //     return puestoEmp?.descripcion || '';
    //   },
    // },
    // {
    //   titleText: 'Tipo de Nómina Empleado',
    //   dataIndex: 'tipo_de_nomina_empleado',
    //   key: 'tipo_de_nomina_empleado',
    //   width: 250,
    //   render: (tneEmp) => tiposDeNominaEmpleado?.find((tne) => tne?.id === tneEmp)?.descripcion || '',
    // },
  ];
  useEffect(() => {
    if (selectedEntrevistador) {
      form.setFieldsValue({
        entrevistador: `${selectedEntrevistador.numero_de_empleado} - ${selectedEntrevistador.nombre} ${selectedEntrevistador.apellido_paterno} ${selectedEntrevistador.apellido_materno || ''}`,
        area_entrevistador: selectedEntrevistador.area || '', // aquí usas el valor que seteaste tras getPlaza
        puesto_entrevistador: selectedEntrevistador.puesto || '',
      });
    }
  }, [selectedEntrevistador, form]);

  const calcularEdad = (fechaNacimiento) => {
    if (!fechaNacimiento) return null;
    const hoy = moment();
    const nacimiento = moment(fechaNacimiento);
    if (!nacimiento.isValid()) return null;
    return hoy.diff(nacimiento, 'years');
  };

  const normalizeCandidate = (c, generosList = [], estadosCivilList = []) => {
    if (!c) return null;

    const generoObj = generosList.find((g) => g.id === c.genero);
    const estadoCivilObj = estadosCivilList.find((e) => e.id === c.estado_civil);

    return {
      nombre: c.numero_y_nombre_completo,
      genero: generoObj?.descripcion || '—',
      estadoCivil: estadoCivilObj?.descripcion || '—',
      edad: calcularEdad(c.fecha_de_nacimiento),
      telefono: c.numero_de_telefono,
      celular: c.numero_de_celular,
      correo: c.correo_electronico,
      fechaNacimiento: c.fecha_de_nacimiento,
      fechaAplicacion: c.solicitud_de_contratacion?.fecha_de_solicitud || null,
      referente: c.referente || '—',
      domicilio: c.domicilio,

      // Información de la vacante
      vacanteArea: c.solicitud_de_contratacion?.directorio_de_area_adscripcion?.clave_y_nombre,
      vacantePuesto: c.solicitud_de_contratacion?.puesto?.clave_y_descripcion,
      vacantePlaza: c.solicitud_de_contratacion?.puesto_plaza?.clave_y_descripcion
        || c.solicitud_de_contratacion?.plaza?.descripcion,
      vacanteTipoEmpleado: c.solicitud_de_contratacion?.tipo_empleado?.descripcion,
      vacanteMotivo: c.solicitud_de_contratacion?.motivo_de_reclutamiento?.nombre,
      vacanteOficio: c.solicitud_de_contratacion?.no_de_oficio,

      // Área solicitante
      // Área solicitante
      solicitanteNombre: c.solicitud_de_contratacion?.empleado?.numero_y_nombre_completo,
      solicitanteArea: c.solicitud_de_contratacion?.directorio_de_area_adscripcion?.clave_y_nombre,
      solicitantePuesto: c.solicitud_de_contratacion?.puesto?.clave_y_descripcion,
      solicitantePlaza: c.solicitud_de_contratacion?.puesto_plaza?.clave_y_descripcion
        || c.solicitud_de_contratacion?.plaza?.descripcion,

      // Otros
      estatusCandidato: c.estado_del_candidato?.descripcion,
      escolaridad: c.solicitud_de_contratacion?.nivel_de_estudios?.nombre || c.nivel_de_estudios?.nombre,
      fuenteReclutamiento: c.fuente_de_reclutamiento?.descripcion ?? '—',
      institucion: c.especialidad_estudio,
      anioGraduacion: c.anioGraduacion,
      cvURL: c.comprobante?.nombre,
      pruebas: c.candidato_pruebas_y_otros,
    };
  };

  const normalized = normalizeCandidate(candidatoDetalle, generos, estadoCivil);

  if (!entrevista) return null;
  const handleUpload = (file) => {
    setArchivo(file);
    message.success(`Archivo cargado: ${file.name}`);
    return false; // Evita subida automática
  };

  const openCompetenciaModal = (record) => {
    setSelectedCompetencia(record);
    competenciaForm.setFieldsValue({
      porcentaje_del_candidato: record.porcentaje_del_candidato,
    });
    setShowCompetenciaModal(true);
  };
  const handleSaveCaracteristicas = async () => {
    try {
      const promises = entrevistasCaracteristicas.map((record) => {
        // Normaliza siempre a true/false
        const payload = {
          presente: record.valor === true,
          no_presente: record.valor === false,
        };

        if (record.id) {
          return patchEntrevistaCaracteristicas(record.id, payload);
        }
        return postEntrevistaCaracteristicas({
          entrevista: entrevista.id,
          caracteristica_observable: record.caracteristica_observable,
          ...payload,
        });
      });

      await Promise.all(promises);
      message.success('Características guardadas correctamente');
    } catch (err) {
      message.error('Error al guardar características observables');
    }
  };

  const handleSaveAndContinue = async (currentTab) => {
    try {
      // Aquí puedes agregar la lógica para guardar los datos del tab actual
      notification.success({
        message: 'Guardado exitoso',
        description: 'Los datos se han guardado correctamente.',
      });

      // Navegar al siguiente tab
      const tabs = ['info', 'entrevista', 'evaluacion'];
      const currentIndex = tabs.indexOf(currentTab);
      if (currentIndex < tabs.length - 1) {
        setActiveTab(tabs[currentIndex + 1]);
      }
    } catch (error) {
      notification.error({
        message: 'Error al guardar',
        description: 'Hubo un problema al guardar los datos.',
      });
    }
  };

  const handleSaveAndFinish = async () => {
    try {
      await form.validateFields();
      const values = form.getFieldsValue();

      if (entrevista?.id) {
        await patchEntrevista(entrevista.id, {
          sueldo_solicitado: values.sueldo_solicitado,
          disponibilidad_laboral: values.disponibilidad_laboral,
        });
      }

      // notification.success({
      //   message: 'Entrevista completada',
      //   description: 'La entrevista se ha guardado exitosamente.',
      // });
      // onClose();
    } catch (error) {
      notification.error({
        message: 'Error al finalizar',
        description: 'Hubo un problema al finalizar la entrevista.',
      });
    }
  };

  const handleSaveNotas = async () => {
    try {
      const values = await notasForm.validateFields();

      // Normalizar strings vacíos → null
      const normalizePayload = (data) => {
        const result = { ...data };
        Object.keys(result).forEach((key) => {
          if (result[key] === '') {
            result[key] = null;
          }
        });
        return result;
      };

      const payload = {
        ...normalizePayload(values),
        entrevista: entrevista.id,
        empleado: selectedEntrevistador?.id || null, // solo el id
      };

      // Ver si ya existe nota para esta entrevista
      const existente = entrevistasNotas.find(
        (n) => Number(n.entrevista) === Number(entrevista.id),
      );

      let response;
      if (existente) {
        response = await patchEntrevistaNotas(existente.id, payload);
      } else {
        response = await postEntrevistaNotas(payload);
      }

      if (response) {
        message.success('Notas guardadas correctamente');
        setEntrevistasNotas((prev) => (existente
          ? prev.map((n) => (n.id === existente.id ? response : n))
          : [...prev, response]));
      }
    } catch (err) {
      message.error('Error al guardar notas');
    }
  };
  const handleSaveSalud = async () => {
    try {
      const values = await saludForm.validateFields();

      // Normalizar payload
      const normalizePayload = (data) => {
        const booleanFields = [
          'padece_alguna_limitacion_fisica',
          'padece_alguna_enfermedad_cronica',
          'padece_o_ha_padecido_depresion',
          'le_han_operado',
          'que_tipo_medicamento_consume',
          'fuma',
          'ingiere_bebidas_alcoholicas',
          'usa_algun_tipo_de_droga',
        ];

        const especificacionFields = [
          'padece_alguna_limitacion_fisica_especificacion',
          'padece_alguna_enfermedad_cronica_especificacion',
          'padece_o_ha_padecido_depresion_especificacion',
          'le_han_operado_especificacion',
          'que_tipo_medicamento_consume_especificacion',
          'fuma_especificacion',
          'ingiere_bebidas_alcoholicas_especificacion',
          'usa_algun_tipo_de_droga_especificacion',
        ];

        const result = { ...data };

        // Normalizar booleans (Select devuelve true/false o undefined)
        booleanFields.forEach((f) => {
          if (result[f] === undefined) {
            result[f] = null; // si no seleccionaron nada
          }
        });

        // Normalizar strings vacíos o undefined → null
        especificacionFields.forEach((f) => {
          if (!result[f] || result[f] === '') {
            result[f] = null;
          } else {
            result[f] = String(result[f]); // siempre string
          }
        });

        return result;
      };

      const payload = {
        ...normalizePayload(values),
        entrevista: entrevista.id,
      };

      const existente = entrevistasSalud.find(
        (s) => Number(s.entrevista) === Number(entrevista.id),
      );

      let response;
      if (existente) {
        response = await patchEntrevistaSalud(existente.id, payload);
      } else {
        response = await postEntrevistaSalud(payload);
      }

      if (response) {
        message.success('Información de salud guardada correctamente');
        setEntrevistasSalud((prev) => (existente
          ? prev.map((s) => (s.id === existente.id ? response : s))
          : [...prev, response]));
      }
    } catch (err) {
      message.error('Error al guardar información de salud');
    }
  };

  // Funciones para manejar datos de tablas
  const handleSaveTrayectoria = async () => {
    try {
      const values = await trayectoriaForm.validateFields();

      // Normalización de payload
      const payload = {
        entrevista: entrevista.id, // fk entrevista
        periodo_inicial: values.periodoInicial.year(),
        periodo_inicial_mes: values.periodoInicial.month() + 1, // 👈 month() es 0-based
        periodo_final: values.periodoFinal.year(),
        periodo_final_mes: values.periodoFinal.month() + 1,
        puesto: values.puesto || null,
        sueldo: values.sueldo || null,
        personal_a_cargo: values.personal || null,
        responsabilidades: values.responsabilidades || null,
        motivo_de_baja: values.motivo || null,
      };

      // Buscar si ya existe una trayectoria para esta entrevista
      const existente = trayectoriaData.find(
        (t) => Number(t.entrevista) === Number(entrevista.id),
      );

      let response;
      if (existente) {
        response = await patchEntrevistaTrayectoria(existente.id, payload);
      } else {
        response = await postEntrevistaTrayectoria(payload);
      }

      if (response) {
        message.success('Trayectoria laboral guardada correctamente');
        setTrayectoriaData((prev) => (existente
          ? prev.map((t) => (t.id === existente.id ? response : t))
          : [...prev, response]));
        trayectoriaForm.resetFields();
        setShowTrayectoriaModal(false);
      }
    } catch (err) {
      message.error('Error al guardar trayectoria laboral');
    }
  };
  const handleEditFamiliar = async (values) => {
    try {
      const payload = {
        ...values,
        entrevista: entrevista.id, // fk entrevista
      };

      const updated = await patchEntrevistaFamiliar(selectedData.key, payload);

      if (updated) {
        setFamiliarData((prev) => prev.map((item) => (item.key === selectedData.key ? { key: updated.id, ...updated } : item)));
        message.success('Familiar actualizado correctamente');
        familiarForm.resetFields();
        setShowFamiliarModal(false);
        setSelectedData(null);
      }
    } catch (error) {
      message.error('Error al actualizar familiar');
    }
  };
  const handleSavePreguntas = async () => {
    try {
      const values = await preguntasForm.validateFields();

      // Normalizar: convertir strings vacíos en null
      const normalizePayload = (data) => {
        const result = { ...data };
        Object.keys(result).forEach((key) => {
          if (result[key] === '') {
            result[key] = null;
          }
        });
        return result;
      };

      const payload = {
        ...normalizePayload(values),
        entrevista: entrevista.id,
      };

      const existente = entrevistatrasectoriaPreguntas.find(
        (p) => Number(p.entrevista) === Number(entrevista.id),
      );

      let response;
      if (existente) {
        //  Siempre debería entrar aquí porque ya se crea al levantar la cita
        response = await patchEntrevistaTrayectoriaPreguntas(existente.id, payload);
      } else {
        // fallback si por alguna razón no existiera
        response = await postEntrevistaTrayectoriaPreguntas(payload);
      }

      if (response) {
        message.success('Preguntas guardadas correctamente');
        setEntrevistaTrayectoriaPreguntas((prev) => (existente
          ? prev.map((p) => (p.id === existente.id ? response : p))
          : [...prev, response]));
      }
    } catch (err) {
      message.error('Error al guardar preguntas');
    }
  };

  const handleAddFamiliar = async (values) => {
    try {
      const payload = {
        entrevista: entrevista.id, // fk a la entrevista actual
        relacion_familiar: values.relacion_familiar,
        nombre: values.nombre,
        edad: values.edad,
        actividad: values.actividad,
        con_quien_vive: values.con_quien_vive,
        aporta_a_la_economia_familiar: values.aporta_a_la_economia_familiar,
      };

      const newFamiliar = await postEntrevistaFamiliar(payload);

      if (newFamiliar) {
        setFamiliarData((prev) => [...prev, { key: newFamiliar.id, ...newFamiliar }]);
        familiarForm.resetFields();
        setShowFamiliarModal(false);
      }
    } catch (error) {
      message.error('Error al agregar familiar');
    }
  };

  const handleSaveCompetencia = async (values) => {
    try {
      const payload = {
        ...selectedCompetencia,
        porcentaje_del_candidato: values.porcentaje_del_candidato,
      };

      const response = await patchEntrevistaCompetencias(selectedCompetencia.id, payload);

      if (response) {
        message.success('Competencia actualizada');
        setEntrevistaCompetencias((prev) => prev.map((c) => (c.id === selectedCompetencia.id ? response : c)));
        setShowCompetenciaModal(false);
      }
    } catch (err) {
      message.error('Error al actualizar competencia');
    }
  };

  const handleDeleteRecord = async (id) => {
    try {
      const success = await deleteEntrevistaFamiliar(id);
      if (success) {
        setFamiliarData((prev) => prev.filter((item) => item.key !== id));
      }
    } catch (error) {
      message.error('Error al eliminar familiar');
    }
  };

  const handleDeleteTrayectoria = async (id) => {
    try {
      const ok = await deleteEntrevistaTrayectoria(id);
      if (ok) {
        setTrayectoriaData((prev) => prev.filter((t) => t.id !== id));
        message.success('Registro eliminado');
      }
    } catch (err) {
      message.error('Error al eliminar trayectoria laboral');
    }
  };

  const trayectoriaColumns = [
    {
      titleText: 'Periodo',
      key: 'periodo',
      width: 180,
      render: (_, record) => {
        const inicio = `${String(record.periodo_inicial_mes).padStart(2, '0')}/${record.periodo_inicial}`;
        const fin = `${String(record.periodo_final_mes).padStart(2, '0')}/${record.periodo_final}`;
        return `${inicio} - ${fin}`;
      },
    },
    {
      titleText: 'Puesto',
      dataIndex: 'puesto',
      key: 'puesto',
      width: 150,
    },
    {
      titleText: 'Sueldo',
      dataIndex: 'sueldo',
      key: 'sueldo',
      width: 120,
      render: (val) => (val ? currencyFormatter(val) : '—'),
    },
    {
      titleText: 'Personal a cargo',
      dataIndex: 'personal_a_cargo',
      key: 'personal_a_cargo',
      width: 150,
    },
    {
      titleText: 'Responsabilidades',
      dataIndex: 'responsabilidades',
      key: 'responsabilidades',
      ellipsis: true,
    },
    {
      titleText: 'Motivo de baja',
      dataIndex: 'motivo_de_baja',
      key: 'motivo_de_baja',
      width: 180,
    },

  ];

  const familiarColumns = [
    {
      titleText: 'Relación',
      dataIndex: 'relacion_familiar',
      key: 'relacion_familiar',
      width: 120,
      render: (id) => {
        const parentesco = entrevistasFamiliarParentesco.find((p) => p.id === id);
        return parentesco ? parentesco.descripcion : id;
      },
    },
    {
      titleText: 'Nombre',
      dataIndex: 'nombre',
      key: 'nombre',
      width: 150,
    },
    {
      titleText: 'Edad',
      dataIndex: 'edad',
      key: 'edad',
      width: 60,
    },
    {
      titleText: 'Actividad',
      dataIndex: 'actividad',
      key: 'actividad',
      width: 120,
    },
    {
      titleText: 'Con quién vive',
      dataIndex: 'con_quien_vive', //  corregido
      key: 'con_quien_vive',
      width: 120,
    },
    {
      titleText: 'Aporta economía',
      dataIndex: 'aporta_a_la_economia_familiar', //  corregido
      key: 'aporta_a_la_economia_familiar',
      width: 100,
      render: (val) => (val ? 'Sí' : 'No'),
    },
  ];

  const competenciasColumns = [
    {
      titleText: 'No.', dataIndex: 'numero', key: 'numero', width: 60,
    },
    { titleText: 'Competencia', dataIndex: 'competencia', key: 'competencia' },
    {
      titleText: '% Requerido',
      dataIndex: 'porcentaje',
      key: 'porcentaje',
      width: 120,
      render: (val) => `${val}%`,
    },
    {
      titleText: '% Candidato',
      dataIndex: 'porcentaje_del_candidato',
      key: 'porcentaje_del_candidato',
      width: 150,
      render: (val) => (val !== null ? `${val}%` : '—'),
    },
    {
      titleText: 'Acciones',
      key: 'acciones',
      width: 100,
      render: (_, record) => (
        <Button type="link" onClick={() => openCompetenciaModal(record)}>
          Editar
        </Button>
      ),
    },
  ];

  return (
    <Card
      onCancel={onClose}
      footer={null}
      width="95%"
      style={{ top: 20 }}
      bodyStyle={{
        maxHeight: 'calc(100vh - 120px)',
        overflowY: 'auto',
        padding: '16px',
      }}
      destroyOnClose
      title={(
        <Title level={3}>
          Entrevista del Candidato -
          {normalized?.nombre}
        </Title>
      )}
    >
      {/* Form global */}
      <Form form={form} layout="vertical">
        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          type="card"
          size="small"
          style={{
            minHeight: '70vh',
          }}
          tabBarStyle={{
            marginBottom: 16,
          }}
        >
          {/* <TabPane tab=" Información" key="info">
            <div style={{ maxHeight: 'calc(100vh - 250px)', overflowY: 'auto', padding: '0 8px' }}>
              <Space align="start" className="mb-5" size="large">
                <Avatar size={72} icon={<UserOutlined />} />
                <div>
                  <Title level={4} style={{ marginBottom: 0 }}>{entrevista.nombre}</Title>
                  <Text type="secondary">{entrevista.email}</Text>
                  <div className="mt-2">
                    <Badge status="processing" text={entrevista.vacantePlaza} style={{ marginRight: 8 }} />
                    <Badge status="default" text={entrevista.estatus} />
                  </div>
                </div>
              </Space>

              // Información Personal
              <Card title="Información Personal" bordered className="mb-4" size="small">
                <Descriptions
                  column={{
                    xs: 1, sm: 2, md: 2, lg: 2,
                  }}
                  size="small"
                  bordered
                >
                  <Descriptions.Item label="Nombre">{normalized?.nombre || '—'}</Descriptions.Item>
                  <Descriptions.Item label="Género">{normalized?.genero || '—'}</Descriptions.Item>
                  <Descriptions.Item label="Edad">{normalized?.edad ?? '—'}</Descriptions.Item>
                  <Descriptions.Item label="Estado Civil">{normalized?.estadoCivil || '—'}</Descriptions.Item>
                  <Descriptions.Item label="Escolaridad">{normalized?.escolaridad || '—'}</Descriptions.Item>
                  <Descriptions.Item label="Teléfono Celular">{normalized?.celular || '—'}</Descriptions.Item>
                  <Descriptions.Item label="Fuente de Reclutamiento">{normalized?.fuenteReclutamiento || '—'}</Descriptions.Item>
                  <Descriptions.Item label="Referente">{normalized?.referente || '—'}</Descriptions.Item>
                </Descriptions>
              </Card>
              //  Información de Vacante
              <Card title="Información de la Vacante" bordered className="mb-4" size="small">
                <Descriptions
                  column={{
                    xs: 1, sm: 2, md: 2, lg: 2,
                  }}
                  size="small"
                  bordered
                >
                  <Descriptions.Item label="Área">{normalized?.vacanteArea ?? '—'}</Descriptions.Item>
                  <Descriptions.Item label="Puesto">{normalized?.vacantePuesto ?? '—'}</Descriptions.Item>
                  <Descriptions.Item label="Plaza">{normalized?.vacantePlaza ?? '—'}</Descriptions.Item>
                  <Descriptions.Item label="Tipo de Empleado">{normalized?.vacanteTipoEmpleado ?? '—'}</Descriptions.Item>
                  <Descriptions.Item label="Motivo de Reclutamiento">{normalized?.vacanteMotivo ?? '—'}</Descriptions.Item>
                  <Descriptions.Item label="Oficio">{normalized?.vacanteOficio ?? '—'}</Descriptions.Item>
                  <Descriptions.Item label="Pruebas Asignadas">
                    {normalized?.pruebas
                      ? [...new Set(normalized.pruebas.split(','))].map((p) => (
                        <Tag key={p.trim()}>{p.trim()}</Tag>
                      ))
                      : '—'}
                  </Descriptions.Item>
                </Descriptions>
              </Card>

              // Información del Área
              <Card title="Información del Solicitante" bordered className="mb-4" size="small">
                <Descriptions
                  column={{
                    xs: 1, sm: 2, md: 2, lg: 2,
                  }}
                  size="small"
                  bordered
                >
                  <Descriptions.Item label="Nombre del Solicitante">{normalized?.solicitanteNombre ?? '—'}</Descriptions.Item>
                  <Descriptions.Item label="Área">{normalized?.solicitanteArea ?? '—'}</Descriptions.Item>
                  <Descriptions.Item label="Puesto">{normalized?.solicitantePuesto ?? '—'}</Descriptions.Item>
                  <Descriptions.Item label="Plaza">{normalized?.solicitantePlaza ?? '—'}</Descriptions.Item>
                </Descriptions>
              </Card>

            </div>

            <Divider />
             <div style={{ textAlign: 'right' }}>
              <Button
                type="primary"
                icon={<SaveOutlined />}
                onClick={() => handleSaveAndContinue('info')}
                size="large"
              >
                Guardar y Continuar
              </Button>
            </div>
          </TabPane> */}

          <TabPane tab=" Evaluación Integral" key="evaluacion">
            <div style={{ minHeight: 0 }}>
              <Tabs
                tabPosition="left"
                defaultActiveKey="generales"
                size="small"
              >
                {/* Sección 1: Generales */}
                <TabPane tab=" Generales" key="generales">
                  <Card
                    title={(
                      <FormSubmitControls
                        label="Generales"
                        // onFinish={() => form && form.submit()}
                        // onCancel={() => form.resetFields()}
                        allowSave
                      />
                    )}
                    className="mt-4"
                    size="small"
                  >
                    <Form
                      form={form}
                      layout="vertical"
                    // onFinish={handleSaveAndFinish}
                    >
                      <Row gutter={[16, 8]}>
                        <Col xs={24} md={12}>
                          <Form.Item label="Nombre del Candidato">
                            <Input value={normalized?.nombre} disabled />
                            <Text type="secondary" style={{ fontSize: '12px' }} disabled>
                              Este campo proviene del módulo de candidatos.
                            </Text>
                          </Form.Item>
                        </Col>

                        <Col xs={24} md={12}>
                          <Form.Item label="Edad">
                            <Input value={normalized?.edad} disabled />
                          </Form.Item>
                        </Col>

                        <Col xs={24} md={12}>
                          <Form.Item
                            label="Sueldo Solicitado"
                            name="sueldo_solicitado"
                            rules={[{ required: false }]}
                          >
                            <CurrencyInput disabled />
                          </Form.Item>
                        </Col>

                        <Col xs={24} md={12}>
                          <Form.Item label="Nivel de Estudios">
                            <Input value={normalized?.escolaridad} disabled />
                            <Text type="secondary" style={{ fontSize: '12px' }}>
                              Este campo proviene del módulo de candidatos.
                            </Text>
                          </Form.Item>
                        </Col>

                        <Col xs={24} md={12}>
                          <Form.Item label="Fuente de Reclutamiento">
                            <Input value={normalized?.fuenteReclutamiento} disabled />
                          </Form.Item>
                        </Col>

                        <Col xs={24} md={12}>
                          <Form.Item
                            label="Disponibilidad Laboral"
                            name="disponibilidad_laboral"
                            rules={[{ required: false }]}
                          >
                            <Input disabled />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Form>
                  </Card>
                </TabPane>

                {/* Sección 2: Trayectoria Laboral */}
                <TabPane tab=" Trayectoria Laboral" key="trayectoria">
                  <Tabs defaultActiveKey="trayectorias" size="small">
                    {/* Sub-tab 1: Trayectorias */}
                    <TabPane tab="Trayectorias" key="trayectorias">
                      <Table
                        controls={{
                          // onClickAdd: () => {
                          //   trayectoriaForm.resetFields();
                          //   setSelectedData(null);
                          //   setShowTrayectoriaModal(true);
                          // },
                          onClickExpand: () => {
                            if (!selectedData) {
                              message.warning('Selecciona una trayectoria para editar');
                              return;
                            }
                            onEditTrayectoria(selectedData);
                            setShowTrayectoriaModal(true);
                          },
                          // onClickDelete: async () => {
                          //   if (!selectedData) {
                          //     message.warning('Selecciona una trayectoria para eliminar');
                          //     return;
                          //   }
                          //   await handleDeleteTrayectoria(selectedData.id);
                          // },
                        }}
                        permission={permission}
                        cols={trayectoriaColumns}
                        data={trayectoriaData}
                        rowSelection={{
                          type: 'radio',
                          selectedRowKeys,
                          onChange: (keys, rows) => {
                            setSelectedRowKeys(keys);
                            setSelectedData(rows[0]);
                          },
                        }}
                        handleOnRowClick={(record) => {
                          setSelectedRowKeys([record.id]);
                          setSelectedData(record);
                        }}
                        customActions={[
                          // {
                          //   onClick: () => {
                          //     trayectoriaForm.resetFields();
                          //     setSelectedData(null);
                          //     setShowTrayectoriaModal(true);
                          //   },
                          //   icon: <PlusOutlined />,
                          //   text: 'Agregar',
                          //   className: 'primary',
                          //   disabledBySelection: false,
                          // },
                          // {
                          //   onClick: () => {
                          //     if (!selectedData) {
                          //       message.warning('Selecciona una trayectoria para editar');
                          //       return;
                          //     }
                          //     trayectoriaForm.setFieldsValue(selectedData);
                          //     setShowTrayectoriaModal(true);
                          //   },
                          //   icon: <EditOutlined />,
                          //   text: 'Editar',
                          //   disabledBySelection: true,
                          //   disabled: !selectedData,
                          // },
                          // {
                          //   onClick: async () => {
                          //     if (!selectedData) {
                          //       message.warning('Selecciona una trayectoria para eliminar');
                          //       return;
                          //     }
                          //     await handleDeleteTrayectoria(selectedData.id);
                          //   },
                          //   icon: <DeleteOutlined />,
                          //   text: 'Eliminar',
                          //   disabledBySelection: true,
                          //   disabled: !selectedData,
                          //   className: 'danger',
                          // },
                        ]}
                      />

                    </TabPane>

                    {/* Sub-tab 2: Competencias */}
                    <TabPane tab="Competencias" key="competencias">
                      <Card size="small" bordered={false}>
                        <Table
                          cols={competenciasColumns.filter((col) => col.key !== 'acciones')} // quitamos la col de Acciones
                          data={entrevistaCompetencias}
                          pagination={false}
                          size="small"
                          locale={{ emptyText: 'No hay competencias registradas' }}
                          rowSelection={{
                            type: 'radio',
                            selectedRowKeys,
                            onChange: (keys, rows) => {
                              setSelectedRowKeys(keys);
                              setSelectedData(rows[0]);
                            },
                          }}
                          handleOnRowClick={(record) => {
                            setSelectedRowKeys([record.id]);
                            setSelectedData(record);
                          }}
                          permission={permission}
                          controls={{
                            onClickExpand: () => {
                              if (!selectedData) {
                                message.warning('Selecciona una competencia para editar');
                                return;
                              }
                              openCompetenciaModal(selectedData);
                            },
                          }}
                        // customActions={[
                        //   {
                        //     onClick: () => {
                        //       if (!selectedData) {
                        //         message.warning('Selecciona una competencia para editar');
                        //         return;
                        //       }
                        //       openCompetenciaModal(selectedData);
                        //     },
                        //     icon: <EditOutlined />,
                        //     text: 'Editar',
                        //     disabledBySelection: true,
                        //     disabled: !selectedData,
                        //   },
                        // {
                        //   onClick: async () => {
                        //     if (!selectedData) {
                        //       message.warning('Selecciona una competencia para eliminar');
                        //       return;
                        //     }
                        //     // si tienes función deleteCompetencia, úsala aquí:
                        //     // await handleDeleteCompetencia(selectedData.id);
                        //     message.info('Aquí iría la lógica de eliminación');
                        //   },
                        //   icon: <DeleteOutlined />,
                        //   text: 'Eliminar',
                        //   disabledBySelection: true,
                        //   disabled: !selectedData,
                        //   className: 'danger',
                        // },
                        // ]}
                        />
                      </Card>
                    </TabPane>

                    {/* Sub-tab 3: Preguntas Abiertas */}
                    <TabPane tab="Preguntas Abiertas" key="preguntas">
                      <Card
                        title={(
                          <FormSubmitControls
                            label="Preguntas Abiertas"
                            // onFinish={() => preguntasForm && preguntasForm.submit()}
                            // onCancel={() => preguntasForm.resetFields()}
                            allowSave
                          />
                        )}
                        className="mt-4"
                        size="small"
                      >
                        <Form
                          form={preguntasForm}
                          layout="vertical"
                        // onFinish={handleSavePreguntas}
                        >
                          <Form.Item
                            label="¿En cuánto tiempo estima su experiencia laboral en el puesto solicitado?"
                            name="en_cuanto_tiempo_estima_su_experia_laboral"
                          >
                            <TextArea rows={2} disabled />
                          </Form.Item>
                          <Form.Item
                            label="¿Qué significa para usted el trabajo?"
                            name="que_significa_para_usted_el_trabajo"
                          >
                            <TextArea rows={2} disabled />
                          </Form.Item>
                          <Form.Item
                            label="¿Tiene una percepción de las responsabilidades que comprende el puesto solicitado?"
                            name="tiene_una_percepcion_de_las_responsabilidades"
                          >
                            <TextArea rows={2} disabled />
                          </Form.Item>
                          <Form.Item
                            label="¿Cuáles son sus habilidades laborales más sobresalientes?"
                            name="cuales_son_las_habilidades_laborales"
                          >
                            <TextArea rows={2} disabled />
                          </Form.Item>
                          <Form.Item
                            label="¿Cuáles son los valores morales?"
                            name="cuales_son_los_valores_morales"
                          >
                            <TextArea rows={2} disabled />
                          </Form.Item>
                          <Form.Item
                            label="¿Cómo se autodescribe? (quién soy yo)"
                            name="como_se_autodescribe"
                          >
                            <TextArea rows={2} disabled />
                          </Form.Item>
                          <Form.Item
                            label="¿Cuál es tu proyecto de vida?"
                            name="cual_es_tu_proyecto_de_vida"
                          >
                            <TextArea rows={2} disabled />
                          </Form.Item>
                          <Form.Item
                            label="De ser usted seleccionado ¿qué está dispuesto a ofrecer al Gobierno Municipal?"
                            name="que_esta_dispuesto_a_ofrecer"
                          >
                            <TextArea rows={2} disabled />
                          </Form.Item>

                          {/* <div style={{ textAlign: 'right', marginTop: 16 }}>
                            <Button
                              type="primary"
                              icon={<CheckOutlined />}
                              onClick={handleSavePreguntas}
                              size="large"
                              style={{ backgroundColor: '#52c41a', borderColor: '#52c41a' }}
                            >
                              Guardar Preguntas
                            </Button>
                          </div> */}
                        </Form>
                      </Card>
                    </TabPane>
                  </Tabs>
                </TabPane>

                {/* Sección 3: Estructura Familiar */}
                <TabPane tab=" Estructura Familiar" key="familiar">
                  <Table
                    controls={{
                      // onClickAdd: () => {
                      //   familiarForm.resetFields();
                      //   setSelectedData(null);
                      //   setShowFamiliarModal(true);
                      // },
                      onClickExpand: () => {
                        if (!selectedData) {
                          message.warning('Selecciona un familiar para editar');
                          return;
                        }
                        familiarForm.setFieldsValue(selectedData);
                        setShowFamiliarModal(true);
                      },
                      // onClickDelete: async () => {
                      //   if (!selectedData) {
                      //     message.warning('Selecciona un familiar para eliminar');
                      //     return;
                      //   }
                      //   await handleDeleteRecord(selectedData.key);
                      // },
                    }}
                    permission={permission}
                    cols={familiarColumns}
                    data={familiarData}
                    pagination={false}
                    scroll={{ x: 700 }}
                    size="small"
                    locale={{ emptyText: 'No hay información familiar registrada' }}
                    rowSelection={{
                      type: 'radio',
                      selectedRowKeys,
                      onChange: (keys, rows) => {
                        setSelectedRowKeys(keys);
                        setSelectedData(rows[0]);
                      },
                    }}
                    handleOnRowClick={(record) => {
                      setSelectedRowKeys([record.key]);
                      setSelectedData(record);
                    }}
                  // customActions={[
                  //   {
                  //     onClick: () => {
                  //       familiarForm.resetFields();
                  //       setSelectedData(null);
                  //       setShowFamiliarModal(true);
                  //     },
                  //     icon: <PlusOutlined />,
                  //     text: 'Agregar',
                  //     className: 'primary',
                  //   },
                  //   {
                  //     onClick: () => {
                  //       if (!selectedData) {
                  //         message.warning('Selecciona un familiar para editar');
                  //         return;
                  //       }
                  //       familiarForm.setFieldsValue(selectedData);
                  //       setShowFamiliarModal(true);
                  //     },
                  //     icon: <EditOutlined />,
                  //     text: 'Editar',
                  //     disabledBySelection: true,
                  //     disabled: !selectedData,
                  //   },
                  //   {
                  //     onClick: async () => {
                  //       if (!selectedData) {
                  //         message.warning('Selecciona un familiar para eliminar');
                  //         return;
                  //       }
                  //       await handleDeleteRecord(selectedData.key);
                  //     },
                  //     icon: <DeleteOutlined />,
                  //     text: 'Eliminar',
                  //     disabledBySelection: true,
                  //     disabled: !selectedData,
                  //     className: 'danger',
                  //   },
                  // ]}
                  />

                </TabPane>

                {/* Sección 4: Salud */}
                <TabPane tab=" Salud" key="salud">
                  <Card
                    title={(
                      <FormSubmitControls
                        label="Salud"
                        // onFinish={() => saludForm && saludForm.submit()}
                        // onCancel={() => saludForm.resetFields()}
                        allowSave
                      />
                    )}
                    className="mt-4"
                    size="small"
                  >
                    <Form
                      form={saludForm}
                      layout="vertical"
                    // onFinish={handleSaveSalud}
                    >
                      <Row gutter={[16, 8]}>
                        {/* Estado general de salud */}
                        <Col xs={24}>
                          <Form.Item
                            label="¿Cómo considera su estado de salud?"
                            name="como_considera_su_estado_salud"
                            initialValue={null}
                          >
                            <TextArea rows={3} disabled />
                          </Form.Item>
                        </Col>

                        {/* Limitación física */}
                        <Col xs={24} md={12}>
                          <Form.Item
                            name="padece_alguna_limitacion_fisica"
                            label="¿Tiene alguna limitación física?"
                            initialValue={false}
                            rules={[{ required: true, message: 'Seleccione una opción' }]}
                            hasFeedback
                          >
                            <Select trueFalse disabled />
                          </Form.Item>
                          <Form.Item
                            name="padece_alguna_limitacion_fisica_especificacion"
                            noStyle
                            preserve
                            initialValue={null}
                          >
                            <Input disabled />
                          </Form.Item>
                        </Col>

                        {/* Enfermedad crónica */}
                        <Col xs={24} md={12}>
                          <Form.Item
                            name="padece_alguna_enfermedad_cronica"
                            label="¿Padece alguna enfermedad crónica?"
                            initialValue={false}
                            rules={[{ required: true, message: 'Seleccione una opción' }]}
                            hasFeedback
                          >
                            <Select trueFalse disabled />
                          </Form.Item>
                          <Form.Item
                            name="padece_alguna_enfermedad_cronica_especificacion"
                            noStyle
                            preserve
                            initialValue={null}
                          >
                            <Input disabled />
                          </Form.Item>
                        </Col>

                        {/* Depresión */}
                        <Col xs={24} md={12}>
                          <Form.Item
                            name="padece_o_ha_padecido_depresion"
                            label="¿Ha tenido episodios de depresión?"
                            initialValue={false}
                            rules={[{ required: true, message: 'Seleccione una opción' }]}
                            hasFeedback
                          >
                            <Select trueFalse disabled />
                          </Form.Item>
                          <Form.Item
                            name="padece_o_ha_padecido_depresion_especificacion"
                            noStyle
                            preserve
                            initialValue={null}
                          >
                            <Input disabled />
                          </Form.Item>
                        </Col>

                        {/* Operaciones */}
                        <Col xs={24} md={12}>
                          <Form.Item
                            name="le_han_operado"
                            label="¿Le han realizado operaciones con secuelas?"
                            initialValue={false}
                            rules={[{ required: true, message: 'Seleccione una opción' }]}
                            hasFeedback
                          >
                            <Select trueFalse disabled />
                          </Form.Item>
                          <Form.Item
                            name="le_han_operado_especificacion"
                            noStyle
                            preserve
                            initialValue={null}
                          >
                            <Input disabled />
                          </Form.Item>
                        </Col>

                        {/* Medicamentos */}
                        <Col xs={24} md={12}>
                          <Form.Item
                            name="que_tipo_medicamento_consume"
                            label="¿Consume algún tipo de medicamento?"
                            initialValue={false}
                            rules={[{ required: true, message: 'Seleccione una opción' }]}
                            hasFeedback
                          >
                            <Select trueFalse disabled />
                          </Form.Item>
                          <Form.Item
                            name="que_tipo_medicamento_consume_especificacion"
                            noStyle
                            preserve
                            initialValue={null}
                          >
                            <Input disabled />
                          </Form.Item>
                        </Col>

                        {/* Tabaquismo */}
                        <Col xs={24} md={12}>
                          <Form.Item
                            name="fuma"
                            label="¿Fuma?"
                            initialValue={false}
                            rules={[{ required: true, message: 'Seleccione una opción' }]}
                            hasFeedback
                          >
                            <Select trueFalse disabled />
                          </Form.Item>
                          <Form.Item
                            name="fuma_especificacion"
                            noStyle
                            preserve
                            initialValue={null}
                          >
                            <Input disabled />
                          </Form.Item>
                        </Col>

                        {/* Alcohol */}
                        <Col xs={24} md={12}>
                          <Form.Item
                            name="ingiere_bebidas_alcoholicas"
                            label="¿Ingiere bebidas alcohólicas?"
                            initialValue={false}
                            rules={[{ required: true, message: 'Seleccione una opción' }]}
                            hasFeedback
                          >
                            <Select trueFalse disabled />
                          </Form.Item>
                          <Form.Item
                            name="ingiere_bebidas_alcoholicas_especificacion"
                            noStyle
                            preserve
                            initialValue={null}
                          >
                            <Input disabled />
                          </Form.Item>
                        </Col>

                        {/* Drogas */}
                        <Col xs={24} md={12}>
                          <Form.Item
                            name="usa_algun_tipo_de_droga"
                            label="¿Usa algún tipo de droga?"
                            initialValue={false}
                            rules={[{ required: true, message: 'Seleccione una opción' }]}
                            hasFeedback
                          >
                            <Select trueFalse disabled />
                          </Form.Item>
                          <Form.Item
                            name="usa_algun_tipo_de_droga_especificacion"
                            noStyle
                            preserve
                            initialValue={null}
                          >
                            <Input disabled />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Form>
                  </Card>
                </TabPane>

                {/* Sección 5: Notas del Entrevistador */}
                <TabPane tab="Notas del Entrevistador" key="notas">
                  <Tabs>
                    {/* Subtab: Características */}
                    <TabPane tab="Características Observables" key="caracteristicas">
                      <Card
                        title={(
                          <FormSubmitControls
                            label="Características Observables"
                            // onFinish={handleSaveCaracteristicas}
                            allowSave
                          />
                        )}
                        className="mt-4"
                        size="small"
                      >
                        <Table
                          cols={columnsCaracteristicasObservables}
                          data={entrevistasCaracteristicas}
                        />
                      </Card>
                    </TabPane>
                    {/* Subtab: Notas */}
                    <TabPane tab="Notas del Entrevistador" key="notas-form">
                      <Card
                        title={(
                          <FormSubmitControls
                            label="Notas del Entrevistador"
                            // onFinish={() => notasForm && notasForm.submit()}
                            // onCancel={() => notasForm.resetFields()}
                            allowSave
                          />
                        )}
                        className="mt-4"
                        size="small"
                      >
                        <Form
                          form={notasForm}
                          // initialValues={{
                          //   telefono_celular: normalized?.celular || normalized?.telefono || null,
                          //   domicilio: normalized?.domicilio || null,
                          // }}
                          layout="vertical"
                        // onFinish={handleSaveNotas}
                        >
                          <Row gutter={[16, 8]}>
                            {/* <Col xs={24} md={12}>
                              <Form.Item
                                label="Número de Teléfono"
                                name="telefono_celular"
                                rules={[{ required: true, message: 'Ingrese el número de teléfono' }]}
                                hasFeedback
                              >
                                <Input />
                              </Form.Item>
                            </Col>

                            <Col xs={24} md={12}>
                              <Form.Item
                                label="Domicilio"
                                name="domicilio"
                                rules={[{ required: true, message: 'Ingrese el domicilio' }]}
                                hasFeedback
                              >
                                <Input />
                              </Form.Item>
                            </Col> */}

                            <Col xs={24} md={12}>
                              <Form.Item label="Observaciones Domicilio" name="observaciones_domicilio">
                                <Input disabled />
                              </Form.Item>
                            </Col>

                            <Col xs={24} md={12}>
                              <Form.Item label="Observaciones Teléfono Celular" name="observaciones_telefono_celular">
                                <Input disabled />
                              </Form.Item>
                            </Col>

                            <Col xs={24}>
                              <Form.Item label="Observaciones Generales" name="observaciones">
                                <TextArea rows={4} disabled />
                              </Form.Item>
                            </Col>

                            {/* Info del entrevistador */}
                            <Col xs={24} md={8}>
                              <Form.Item label="Entrevistador" name="entrevistador">
                                <Input disabled />
                              </Form.Item>
                            </Col>
                            <Col xs={24} md={8}>
                              <Form.Item label="Área" name="area_entrevistador">
                                <Input disabled />
                              </Form.Item>
                            </Col>
                            <Col xs={24} md={8}>
                              <Form.Item label="Puesto" name="puesto_entrevistador">
                                <Input disabled />
                              </Form.Item>
                            </Col>
                            <Col xs={24} md={8}>
                              <Form.Item label="Plaza" name="plaza_entrevistador">
                                <Input disabled />
                              </Form.Item>
                            </Col>
                          </Row>
                        </Form>
                      </Card>
                    </TabPane>
                  </Tabs>
                </TabPane>
              </Tabs>

            </div>
          </TabPane>

          {/* <TabPane tab=" Resultado de la Entrevista" key="entrevista">
            <div style={{ maxHeight: 'calc(100vh - 250px)', overflowY: 'auto', padding: '0 8px' }}>
              <Row gutter={[16, 16]}>
                <Col xs={24} lg={12}>
                  <Card title="Resumen de Entrevista" bordered className="mb-4" size="small">
                    <TextArea
                      rows={6}
                      placeholder="Escribe aquí el resumen o evaluación de la entrevista..."
                      value={resumen}
                      onChange={(e) => setResumen(e.target.value)}
                    />
                  </Card>
                </Col>
                <Col xs={24} lg={12}>
                  <Card title="Archivo adjunto (opcional)" bordered size="small">
                    <Upload
                      beforeUpload={handleUpload}
                      showUploadList={archivo ? [{ name: archivo.name }] : false}
                      maxCount={1}
                    >
                      <Button block>
                        <UploadOutlined />
                        Subir archivo PDF
                      </Button>
                    </Upload>
                    {archivo && (
                    <div style={{ marginTop: 8, padding: 8, background: '#f5f5f5' }}>
                      <Text>
                        Archivo:
                        {archivo.name}
                      </Text>
                    </div>
                    )}
                  </Card>
                </Col>
              </Row>
            </div>

            <Divider />
            <div style={{ textAlign: 'right' }}>
              <Button
                type="primary"
                icon={<SaveOutlined />}
                onClick={() => handleSaveAndContinue('entrevista')}
                size="large"
              >
                Guardar y Continuar
              </Button>
            </div>
          </TabPane> */}

        </Tabs>

        {/* Modal para agregar trayectoria laboral */}
        <Modal
          open={showTrayectoriaModal}
          closable={false}
          maskClosable={!loading}
          keyboard={!loading}
          footer={null}
          width={600}
          forceRender
          title={(
            <FormSubmitControls
              label={`${selectedTrayectoria ? 'Editar' : 'Agregar'} Trayectoria Laboral`}
              // onFinish={() => trayectoriaForm && trayectoriaForm.submit()}
              onCancel={() => {
                setShowTrayectoriaModal(false);
                trayectoriaForm.resetFields();
                setSelectedTrayectoria(null);
              }}
              loading={loading}
              allowSave
            />
          )}
          onCancel={() => {
            setShowTrayectoriaModal(false);
            trayectoriaForm.resetFields();
          }}
        >
          <Form
            form={trayectoriaForm}
            layout="vertical"
          // onFinish={handleSaveTrayectoria}
          >
            <Row gutter={[16, 8]}>
              <Col xs={24} md={12}>
                <Form.Item
                  label="Periodo Inicial"
                  name="periodoInicial"
                  rules={[{ required: true, message: 'Selecciona el periodo inicial' }]}
                >
                  <DatePicker
                    picker="month"
                    style={{ width: '100%' }}
                    placeholder={null}
                    disabled
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  label="Periodo Final"
                  name="periodoFinal"
                  rules={[{ required: true, message: 'Selecciona el periodo final' }]}
                >
                  <DatePicker
                    picker="month"
                    style={{ width: '100%' }}
                    placeholder={null}
                    disabled
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  label="Puesto"
                  name="puesto"
                  rules={[{ required: true, message: 'Ingresa el puesto' }]}
                >
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  label="Sueldo"
                  name="sueldo"
                  rules={[{ required: true, message: 'Ingresa el sueldo' }]}
                >
                  <Input prefix="$" disabled />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item label="Personal a Cargo" name="personal">
                  <Input type="number" disabled />
                </Form.Item>
              </Col>
              <Col xs={24}>
                <Form.Item
                  label="Responsabilidades"
                  name="responsabilidades"
                  rules={[{ required: true, message: 'Describe las responsabilidades' }]}
                >
                  <TextArea rows={3} disabled />
                </Form.Item>
              </Col>
              <Col xs={24}>
                <Form.Item
                  label="Motivo de Baja"
                  name="motivo"
                  rules={[{ required: true, message: 'Ingresa el motivo de baja' }]}
                >
                  <Input disabled />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>

        {/* Modal para agregar familiar */}
        <Modal
          open={showFamiliarModal}
          closable={false}
          maskClosable={!loading}
          keyboard={!loading}
          footer={null}
          width={500}
          forceRender
          title={(
            <FormSubmitControls
              label={`${selectedData ? 'Editar' : 'Agregar'} Familiar`}
              // onFinish={() => familiarForm && familiarForm.submit()}
              onCancel={() => {
                setShowFamiliarModal(false);
                familiarForm.resetFields();
                setSelectedData(null); // 👈 limpiar selección siempre
              }}
              loading={loading}
              allowSave
            />
          )}
          onCancel={() => {
            setShowFamiliarModal(false);
            familiarForm.resetFields();
            setSelectedData(null);
          }}
        >
          <Form
            form={familiarForm}
            layout="vertical"
          /* onFinish={(values) => {
            if (selectedData) {
              // 👉 Si hay selección, es edición
              handleEditFamiliar(values);
            } else {
              // 👉 Si no hay selección, es alta nueva
              handleAddFamiliar(values);
            }
          }} */
          >
            <Row gutter={[16, 8]}>
              <Col xs={24} md={12}>
                <Form.Item
                  label="Relación Familiar"
                  name="relacion_familiar"
                  rules={[{ required: true, message: 'Selecciona la relación familiar' }]}
                >
                  <Select
                    dataSource={entrevistasFamiliarParentesco} //  la lista que traes de la API
                    labelProp="descripcion" //  muestra la descripción
                    keyProp="id"
                    disabled
                  />
                </Form.Item>
              </Col>

              <Col xs={24} md={12}>
                <Form.Item
                  label="Nombre"
                  name="nombre"
                  rules={[{ required: true, message: 'Ingresa el nombre' }]}
                >
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  label="Edad"
                  name="edad"
                  rules={[{ required: true, message: 'Ingresa la edad' }]}
                >
                  <Input suffix="años" type="number" min={0} max={120} disabled />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  label="Actividad"
                  name="actividad"
                  rules={[{ required: true, message: 'Ingresa la actividad' }]}
                >
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col xs={24}>
                <Form.Item
                  label="Con quién vive"
                  name="con_quien_vive"
                  rules={[{ required: true, message: 'Especifica con quién vive' }]}
                >
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col xs={24}>
                <Col xs={24}>
                  <Form.Item
                    label="Aporta a la economía familiar"
                    name="aporta_a_la_economia_familiar"
                    rules={[{ required: true, message: 'Especifica si aporta a la economía' }]}
                    hasFeedback
                  >
                    <Select
                      trueFalse
                      disabled
                    />
                  </Form.Item>
                </Col>
              </Col>
            </Row>

          </Form>
        </Modal>
      </Form>
      <Modal
        open={showCompetenciaModal}
        closable={false}
        maskClosable={!loading}
        keyboard={!loading}
        footer={null}
        title={(
          <FormSubmitControls
            label="Editar Competencia"
            // onFinish={competenciaForm.submit}
            onCancel={() => setShowCompetenciaModal(false)}
            loading={loading}
            allowSave
          />
        )}
        onCancel={() => setShowCompetenciaModal(false)}
        forceRender
        width={400}
      >
        <Form
          form={competenciaForm}
          layout="vertical"
        // onFinish={handleSaveCompetencia}
        >
          <Form.Item
            label="Porcentaje del Candidato"
            name="porcentaje_del_candidato"
            rules={[{ required: true, message: 'Ingresa un porcentaje' }]}
          >
            <Input type="number" min={0} max={100} suffix="%" />
          </Form.Item>

        </Form>
      </Modal>
      <CustomSearch
        form={form}
        open={openSearchEntrevistador}
        setVisible={setOpenSearchEntrevistador}
        modalTitle="Buscar Entrevistador"
        firstInputLabel="No. de Empleado"
        firstInputName="numero_de_empleado"
        secondInputLabel="Nombre del Empleado"
        secondInputName="nombre"
        searchInputLabel="Apellido Paterno"
        searchInputName="apellido_paterno"
        thirdInputLabel="Apellido Materno"
        thirdInputName="apellido_materno"
        inputsNeeded={3}
        selectsNeeded={0}
        paginatedTable
        modalWidth={1200}
        columns={columnsEmpleado}
        baseURI={baseURIPaginationEntrevistador}
        setSelectedRow={setSelectedEntrevistador}
        onFinishGet={getEmpleadosConDatosOpFilteredPaginated}
        data={dataSearchEntrevistador}
        setData={setDataSearchEntrevistador}
        searchData={searchDataEntrevistador}
        onChange={(row) => {
          onChangeEntrevistador(row);
          setOpenSearchEntrevistador(false);
        }}
      />

    </Card>
  );
}
